<template>
  <div id="app" class="flex flex-row bg-gray-100" :style="loadingpage?'background-color: #fff;':''">

    <Login v-if="!login"> </Login>

    <side-bar v-if="login && user && user.status == 'active' && $route.name!='createStore'" :user="user"></side-bar>
    <main v-if="login" :class="!ShowSidebar() || resize()?'mll-0 show-menu':''" class="flex ml-5 flex-col flex-auto w-full min-w-0">
      <top-bar v-if="$route.name!='createStore'" :user="user" :idWharhouse="idWharhouse" :sous_idWharhouse="sous_idWharhouse" :sous_warehouses="sous_warehouses" class="sticky top-0"></top-bar>
       <vue-ins-progress-bar></vue-ins-progress-bar>
      <router-view :currentUser="user" :idWharhouse="idWharhouse" :sous_idWharhouse="sous_idWharhouse" :sous_warehouses="sous_warehouses"/>
     <div v-if="$route.name!='createStore'" class="relative  flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent"><span class="font-medium text-secondary">speedliv © {{new Date().getFullYear()}}</span></div> 
     <vue-modal-2  name="ModalFormation" :headerOptions="{title: 'Formation videos'}" :noFooter="true" modalSize="xl" @on-close="closeModal()">
          <div class="bg-white rounded-lg mb-10">
            <h3 class="font-bold mb-4 pl-5">Vidéos tutoriels pour utiliser la plateforme CODINAFRICA (<img data-v-37e6d7d6="" src="https://static.dwcdn.net/css/flag-icons/flags/4x3/fr.svg" alt="fr" class="h-4 w-5 inline-block">)</h3>
            <div class="grid lg:grid-cols-3 grid-cols-3 gap-6 videos">
                <iframe id="video" class="mt-3"  src="https://www.youtube.com/embed/aBFvrqwfrKM?si=5UqVvGGl8tmmjo4f" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                <iframe  class="mt-3"  src="https://www.youtube.com/embed/i5PVHk_fmBU?si=0GpqvGvhropaKeIk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                <iframe  class="mt-3"  src="https://www.youtube.com/embed/DIZyhb9HYBo?si=53rj8np-vqC7HJ42" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
            <h3 class="font-bold my-4 pr-5" style="direction: rtl;">فيديوهات تعليمية لكيفية استعمال منصة CODINAFRICA (<img data-v-37e6d7d6="" src="https://static.dwcdn.net/css/flag-icons/flags/4x3/ma.svg" alt="fr" class="h-4 w-5 inline-block">)</h3>
            <div style="direction: rtl;" class="grid lg:grid-cols-3 gap-6 videos" >
              <iframe class="mt-3" src="https://www.youtube.com/embed/3Oy-DTUQVuY?si=ZZPO01MM9ZbmUKto" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              <iframe class="mt-3" src="https://www.youtube.com/embed/hAbTh7y8LcA?si=gUw3Om1gmoCLACxJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              <iframe class="mt-3" src="https://www.youtube.com/embed/vm9lUo-j0C8?si=33rFl0RmJG2OXkIe" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>

            <h3 class="font-bold my-4 pr-5" style="direction: rtl;">شرح طريقة UPsell</h3>
            <div style="direction: rtl;" class="grid lg:grid-cols-3 gap-6 videos" >
                <iframe class="mt-3" src="https://www.youtube.com/embed/fGNyZCfFNkQ?si=4AsCqE6ke8e9lubr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>


            <h3 class="font-bold mb-4 pl-5">Intégration codinafrica && Google Sheet</h3>
            <div class="grid lg:grid-cols-3 gap-6 videos" >
                <iframe class="mt-3" src="https://www.youtube.com/embed/nWA--crrvuQ?si=0y7Nz5_bNTFhiR2j" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>

          </div>
      </vue-modal-2>  
      
    </main>

    <div v-if="loadingpage" id="loadingpage">
        <div class="loader loader-mixed">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:svgjs="http://svgjs.com/svgjs" xmlns:xlink="http://www.w3.org/1999/xlink" width="120" height="120"><svg xmlns="http://www.w3.org/2000/svg" class="lds-microsoft" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100" style="background:0 0" width="120" height="120"><g class="color000 svgShape"><circle cx="73.801" cy="68.263" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(125.399 50 50)"><animateTransform attributeName="transform" begin="0s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="68.263" cy="73.801" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(153.871 50 50)"><animateTransform attributeName="transform" begin="-0.062s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="61.481" cy="77.716" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(182.969 50 50)"><animateTransform attributeName="transform" begin="-0.125s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="53.916" cy="79.743" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(213.399 50 50)"><animateTransform attributeName="transform" begin="-0.187s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="46.084" cy="79.743" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(241.838 50 50)"><animateTransform attributeName="transform" begin="-0.25s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="38.519" cy="77.716" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(267.328 50 50)"><animateTransform attributeName="transform" begin="-0.312s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="31.737" cy="73.801" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(289.993 50 50)"><animateTransform attributeName="transform" begin="-0.375s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="26.199" cy="68.263" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(308.811 50 50)"><animateTransform attributeName="transform" begin="-0.437s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><animateTransform attributeName="transform" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;0 50 50"/></g></svg></svg>
        </div>
        <div class="loading-info">Loading DATA ...</div>
    </div>
    <vue-modal-2  name="RefreshPage" :headerOptions="{title: `Nouvelle mise à jour`}" :noFooter="true" modalSize="md">
          <div class="bg-white rounded-lg">
              <div class="rounded-lg">
                <p class="p-4 pt-0 font-bold"><svg class="fill-current mr-1 inline-block" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11.998 2.001c5.517 0 9.997 4.48 9.997 9.997 0 5.518-4.48 9.998-9.997 9.998-5.518 0-9.998-4.48-9.998-9.998 0-5.517 4.48-9.997 9.998-9.997zm-4.496 6.028-.002-.825c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.048c0 .414.336.75.75.75h3.022c.414 0 .75-.336.75-.75s-.336-.756-.75-.756h-1.512c.808-1.205 2.182-1.998 3.74-1.998 2.483 0 4.5 2.016 4.5 4.5 0 2.483-2.017 4.5-4.5 4.5-1.956 0-3.623-1.251-4.242-2.997-.106-.299-.389-.499-.707-.499-.518 0-.88.513-.707 1.001.825 2.327 3.048 3.995 5.656 3.995 3.312 0 6-2.689 6-6 0-3.312-2.688-6-6-6-1.79 0-3.399.786-4.498 2.031z" fill-rule="nonzero"/></svg> 
                  Une nouvelle mise à jour améliorée de l'application est maintenant disponible, actualiser la page SVP. 
                </p>
              </div>
              <div class="p-4 w-full text-right">
                  <button  @click="RefreshPage()" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-green-600 rounded-lg hover:bg-green-700 hover:text-white font-bold text-sm loidingconfirm relative"><i style="vertical-align: middle;" class="material-icons text-white mr-1">refresh</i> Actualiser maintenant</button>
              </div>
          </div>
      </vue-modal-2>   
    


  </div>
</template>
<script>
//import button from './components/~/button.vue';

export default {
  //components: { button },
  data() {
    return {
      login: false,
      loading:false,
      loadingpage:false,
      fullPage:false,
      user: {},
      typeUser:"",
      idWharhouse:null,
      sous_idWharhouse:null,
      sous_warehouses:[],
    };
  },
  created() {
    console.log('document.readyState -----',document.readyState )
    if(document.readyState == 'loading')  {this.loadingpage=true}
    let vm = this;
    document.addEventListener('readystatechange',function (ev) {
      console.log("statechange", document.readyState);
      if (document.readyState == "complete") { 
        console.log("statechange vv", document.readyState);
          setTimeout(function () { vm.loadingpage=false; } , 800)
          console.log("statechange vv",  vm.loadingpage);
        } 
    })
    
  },
  computed: {
    itemsSousWarehousesLength() {
       return this.$store.state.sous_warehouses.length;
    }
  }, 
  watch: {
    '$store.state.loading': async function(oldVal, newVal) {
          console.log('new loading-----',oldVal)
            this.loadingpage=oldVal
    },
    '$store.state.update': async function(oldVal, newVal) {
        console.log('new update data mise ajour-----',oldVal);
        console.log('new update pr_version mise ajour-----',this.$store.state.pr_version);
       // if(oldVal) this.openClosePopup('open');
        //this.loadingpage=oldVal
    },
    "$store.state.wharhouse.warhouseSelected": {
      async handler(newValue, oldValue) {
             console.log('oldValue--------',newValue)
             await this.getwharhouseId(newValue.code||newValue);
             console.log('country--------',newValue)
             console.log('id ware--------',this.idWharhouse)
            },
            deep: true
    },
    "$store.state.wharhouse.sous_warhouseSelected": {
           async handler(newValue, oldValue) {
                console.log('oldValue sous_warhouseSelected--------',newValue)
                this.sous_idWharhouse=newValue;
            },
            deep: true
      },
      itemsSousWarehousesLength (val, oldVal) {
          console.log('lenght sous_warehouses changed!',this.$store.state.sous_warehouses);
          if(this.$store.state.sous_warehouses){
            this.sous_warehouses=this.$store.state.sous_warehouses;
            console.log('sous_warehouses changed!',this.sous_warehouses);
          }
      }
  },
  async mounted() {
    console.log('app 11 -----',this.$store.state.wharhouse.warhouseSelected)
   await this.getAccess();
   //await this.getwharhouseId(this.$store.state.wharhouse.warhouseSelected);
   document.onreadystatechange = (event) => { 
    console.log('document.readyState onreadystatechange -----',event)
        if(document.readyState == "complete") { 
          this.loadingpage=false;
        } 
      }
  },
  methods: {
    closeModal(){
        this.$vm2.close('ModalFormation');
        $("iframe").each(function() { 
            var src= $(this).attr('src');
            $(this).attr('src',src);  
       });
    },
    pauseVideo(){
      var iframe = document.getElementById('video');
      // $f == Froogaloop
      var player = $f(iframe);

      var pauseButton = document.getElementById("click-to-close");
    // it is now hidden, we can't access it anymore...
        player.api("pause");
    },
    async getwharhouseId(country){
        const resW = await this.$server.get("warehouses", {country:country}); 
        if(resW && resW.content) this.idWharhouse=resW.content;
        //console.log('satatu get-------------- app',this.idWharhouse)
    },
     RefreshPage(){
      console.log('new update pr_version mise ajour-----',this.$store.state.pr_version);
       if(this.user && this.user._id) {
          localStorage.setItem('pr-version',this.$store.state.pr_version);
          window.location.reload();
        }
    },
     openClosePopup(type){
      console.log('type-------',type)
       if(type=='open') this.$vm2.open('RefreshPage');
       else this.$vm2.close('RefreshPage');
    },
     ShowSidebar(){
       return  this.$store.getters.ShowSidebar;
    },
    resize(){
       return  this.$store.getters.resize;
    },
    async getAccess() {
      this.loading=true;
      const tokenExist = this.$jwtService.verifyToken();
      if (tokenExist) {
        const token = this.$jwtService.getToken();
        const dataUser = await this.$me;
        if (dataUser && dataUser.status &&  dataUser.status == 200) {
          this.typeUser=dataUser.content.type;
          this.user=dataUser.content;
           const resW = await this.$server.get("warehouses", {country:this.$store.state.wharhouse.warhouseSelected}); 
           if(resW && resW.content) this.idWharhouse=resW.content;
           if(['Seller','StockManager','Administrateur'].indexOf(this.user.type) == -1){ 
              const resW = await this.$server.search("warehouses", { country: this.idWharhouse.country,all:true,limit:10}); 
              if(resW.content && resW.content.results) {
                this.user.sous_warehouses=resW.content.results.filter(item => !item.is_primary).sort((a,b) => (a._id > b._id) ? 1 : ((b._id > a._id) ? -1 : 0));
                this.sous_warehouses=this.user.sous_warehouses.map(warehouse => ({ _id: warehouse._id, name: warehouse.name }));
                if(this.sous_warehouses && this.sous_warehouses.length>0) this.sous_warehouses.splice(0, 0, {_id:'all',name:'all'});
                this.$store.dispatch("actionSousWarehouses",{sous_warehouses:this.sous_warehouses}); 
              }
           }else {this.user.sous_warehouses=this.sous_warehouses=[];}
           this.sous_idWharhouse=await this.$store.getters["wharhouse/sous_warhouseSelected"]({user:_.pick(this.user,['sous_warehouses','type'])})||null;
           this.$store.dispatch("actionSeller",{user:this.user}); 
          this.login = true;
        }
      }
      this.loading=false;
    },
  },
};
</script>
<style>
.font-bold-imp {
    font-weight: 700 !important;
}
#tagsbuttons{
  display: block !important;
}
.py-0-imp {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.inline-block-imp {
    display: inline-block !important;
}
.invoice-table tbody:last-child {
    border: none;
}
.invoice-table .table>tbody {
    vertical-align: inherit;
}
.invoice-table .table-nowrap td,.invoice-table  .table-nowrap th {
    white-space: nowrap;
}
.invoice-table .table th {
    font-weight: 500;
    text-align: left;
    font-size: 15px;
}
.invoice-table  .table-borderless>:not(caption)>*>* {
    border-bottom-width: 0;
}
.tab-pay{
    border: 1px dashed #8d9091!important;
    padding: 10px;
}
.app-theme .btn.btn-prime {
  background: #444;
  background: linear-gradient(#555,#444);
  color: #fff;
}
.app-theme .btn {
  font-size: 11px;
  font-weight: 500;
  color: #555;
  background: #f4f4f4;
  background: linear-gradient(#f4f4f4,#e4e4e4);
  border-radius: 3px;
  border: 1px solid #999;
  display: inline-block;
  padding: 4px;
  overflow: hidden;
  text-decoration: none;
  min-width: 30px;
  cursor: pointer;
  transition: ease-in .1s;
}
svg:not(:root).svg-inline--fa_2 {
  overflow: visible;
}
.svg-inline--fa_2 {
  display: inline-block;
  font-size: inherit;
  height: 15px;
  width: 15px;
  overflow: visible;
  vertical-align: sub;
}

.invoice-table .table-sm>:not(caption)>*>* {
    padding: 0.3rem 0.25rem;
}
.invoice-table .bg-light {
    background-color: #f3f6f9;
}

.invoice-table .border-0 {
    border: 0!important;
}
.invoice-table .form-control {
    display: block;
    width: 100%;
    padding: 0.3rem 0.7rem;
    font-size: .825rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #d9e4ef;
    background-clip: padding-box;
    border: 1px solid #ced4da !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0.25rem;
    -webkit-transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
}
.mx-input{
  border: none;
  box-shadow: none;
}
.multi-range-slider-bar-only .bar-inner {
  background-color: #05e27c !important;
}    
.status-war .vs__selected{
  font-size: 10px;
  font-weight: 600;
}

.show-menu .btn-bottom-toolbar{
  width: 87%;
  padding-right: 25px;
}
.btn-bottom-toolbar{
    position: fixed;
    bottom: 0;
    padding: 12px;
    width: 100%;
    box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
    background: #fff;
    z-index: 60;
    border-top: 1px solid #ededed;
}
.text-total-m{
    background-color: rgb(148 148 148);
    line-height: .95;
    padding: 0.35em 0.65em;
    font-size: 0.7em;
    font-weight: 700;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25em;
    color: rgb(248 248 246);
    display: inline-block;
}
.vue-circular-progress .circle__svg {
  display: inline-block;
}
.rounded-circle {
  border-radius: 50% !important;
}
.font-bold-imp {
    font-weight: 700 !important;
}
.empty-row{
   background: repeating-linear-gradient( 53deg , #bfc0c2 4%, #fcfcff 11px 6%, #ffffff 10px 7%, #9d9c9c 15px);
}
.focus\:shadow-outline:focus {
    margin-right: 6px;
}
.bg-dauchete{
  background-color: #f75c03 !important;
}
.bg-refund{
  background-color: #D90368 !important;
}
.bg-previous{
  background-color: #820263 !important;
}
.badge-soft-success {
  color: #e8bc52;
background-color: rgba(232,188,82,.1);
display: inline-block;
padding: 2px 2px;
font-size: 14px;
font-weight: 500;
line-height: 1;
text-align: center;
white-space: nowrap;
vertical-align: baseline;
border-radius: 10px;
}
.videos iframe{
  margin: auto;
}
.rwd-media {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 */
}

.rwd-media iframe,
.rwd-media video {
  position: absolute;
  width: 100%;
  height: 100%;  
}
.ware-primary{
  background: linear-gradient(90deg,rgb(25 166 157 / 64%),rgb(25 166 157 / 6%));
}
.ware-parentt{
  background: linear-gradient(90deg,rgb(25 166 157 / 24%),rgb(25 166 157 / 0%));
}
@keyframes blinkdot {
    0% { opacity: .2; }
    20% { opacity: 1; }
    100% { opacity: .2; }
}
.loading-excel span {
    animation-name: blinkdot;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
    font-weight: 900;
    vertical-align: text-bottom;
}
.loading-excel span:nth-child(2) {
    animation-delay: .2s;
}
.loading-excel span:nth-child(3) {
    animation-delay: .4s;
}
.animation-pulse {
    -webkit-animation: shadow-pulse 1s infinite;
    animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse{ 
    0%{box-shadow:0 0 0 0px rgba(30, 112, 185);}
    100%{box-shadow:0 0 0 15px rgba(0, 0, 0, 0);}
}
.exp-expedition{
  background: linear-gradient(90deg,rgb(247 165 68 / 52%),rgb(240 162 70 / 0%));
}
.exp-transfer{
  background: linear-gradient(90deg,rgb(113 226 245 / 64%),rgb(102 223 243 / 18%));
}
.ware_prin {
    position: relative;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 15px;
    box-sizing: border-box;
    margin-left: 7px;
}
.ware_prin::before {
    position: absolute;
    top: 47px;
    left: 0;
    width: 53px;
    height: 1px;
    margin: auto;
    content: "";
    background-color: #666;
}
.ware_prin::after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    height: 48px;
    width: 1px;
    content: "";
    background-color: #666;
}
.mll-4 {
    margin-left: 4em;
}
.data-ss{
    border: 2px dashed #858585;
    border-radius: 8px;
    background-color: rgba(255,255,255,1);
    font-size: 12px;
    line-height: 1.28;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    box-sizing: border-box;
    position: relative;
    padding: 15px;
    overflow-x: auto;
    overflow-y: auto;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;
  }
  .row-data{
    margin-bottom: 8px;
    margin-top: 5px;
  }
  .row-data .title-1{
    font-weight: 400;
    word-wrap: normal;
    color: rgba(0,0,0,.85);
    white-space: inherit;
    font-size: .875rem !important;
  }
  .row-data .content-1{
    text-align: left;
    color: rgba(0,0,0,.75);
    font-weight: 700;
    word-wrap: normal;
    font-size: .875rem !important;
  }
  .header-1{
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row;
    display: flex;
    font-size: 12px;
    line-height: 1.28;
  }
  .header-1 .content{
    box-sizing: border-box;
    height: 60px;
  }
  .header-1 .title{
    white-space: nowrap;
    min-width: 0;
    overflow-x: hidden;
    overflow-y: hidden;
    text-align: left;
    text-overflow: ellipsis;
    color: rgba(0,0,0,.75);
    font-weight: 700;
    font-size: 1.125rem !important;
    line-height: 1.33334 !important;
  }
  .header-1 .content-1{
    white-space: nowrap;
    min-width: 0;
    overflow-x: hidden;
    overflow-y: hidden;
    font-weight: normal;
    text-overflow: ellipsis;
    color: rgba(0,0,0,.75);
    word-wrap: normal;
    line-height: 1.42858 !important;
    font-size: .875rem !important;
  }
  .header-table{
    width: 100%;
    display: flex;
    align-items: center;
    height: 48px;
    box-sizing: border-box;
    padding-top: 10px;
    padding-bottom: 10px;
    box-shadow: inset 0 -1px 0 #dadcde;
    border-top: 1px solid #CECDCD;
  }
  .header-table .title{
    display: flex;
    align-items: center;
    min-width: 0;
    text-align: left;
    color: rgba(0,0,0,.75);
    font-weight: 700;
    word-wrap: normal;
    line-height: 1.42858;
    white-space: inherit;
    font-size: .875rem;
  }
  .header-table .title-1{
    font-weight: 400 !important;
  }
  .xz84dc7 {
    width: 60%;
  }
  .x8yj6t5 {
    width: 20%;
  }
  .x8yj6t5 {
    width: 20%;
  }
.mb-14 {
    margin-bottom: 5rem;
}
hr:not([size]) {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 0px;
    border-left: none;
    border-bottom: 2px solid #19a69d;
}
.avatar-xs {
    height: 2rem;
    width: 2rem;
}
.rounded-circle {
    border-radius: 50%!important;
}
.align-items-center {
    -webkit-box-align: center!important;
    -ms-flex-align: center!important;
    align-items: center!important;
}
.d-flex {
    display: -webkit-box!important;
    display: -ms-flexbox!important;
    display: flex!important;
}
.me-2 {
    margin-right: 0.5rem!important;
}
.flex-shrink-0 {
    -ms-flex-negative: 0!important;
    flex-shrink: 0!important;
}
.flex-grow-1 {
    -webkit-box-flex: 1!important;
    -ms-flex-positive: 1!important;
    flex-grow: 1!important;
}
.call-post{
    border: 2px solid #959292;
    border-style: dashed;
    padding: 1px;
    border-radius: 5%;
    font-size: 10px;
    font-weight: 600;
    align-items: center;
    justify-content: center;
    line-height: 1px;
    margin-top: 2px;
}
.vue-circular-progress .percent__int {
    font-size: 16px !important;
}
.mb-130{
  margin-bottom: 130px;
}
@keyframes blinkdot {
    0% { opacity: .2; }
    20% { opacity: 1; }
    100% { opacity: .2; }
}
.loading-excel span {
    animation-name: blinkdot;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
    font-weight: 900;
    vertical-align: text-bottom;
}
.loading-excel span:nth-child(2) {
    animation-delay: .2s;
}
.loading-excel span:nth-child(3) {
    animation-delay: .4s;
}
#vm2_box_ModalChangeStatus .s-sidebarwidget {
  margin-bottom: 80px;
}

#vm2_box_modalConfirm .vm2__close,#vm2_box_Params .vm2__close,#vm2_box_upsell .vm2__close,#vm2_box_ModalChangeStatusByDauchette .vm2__close,#vm2_box_RefreshPage .vm2__close,#vm2_box_ModalPay .vm2__close,#vm2_box_warehouseParent .vm2__close,#vm2_box_smsSend .vm2__close,#vm2_box_ModalRefunds .vm2__close,#vm2_box_myModalSettings .vm2__close{
  display: none;
}
.mx-datepicker{
  width: 100%;
}
.sucess{
  color: #1b9c0d;
}
.input-style{
    padding: 0.375rem 0.75rem;
    font-size: 0.9375rem;
    line-height: 1.6;
    color: #9493a9 !important;
    background-color: #f4f3f9;
    background-clip: padding-box;
    border: 1px solid #e1e0ea;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    border-radius: 3px;
  }
.bg-dauch{
  border: 2px solid #dcdcde;
  border-radius: 0.25rem;
  background-color: #fff;
}
.w-full-imp  {
  width: 100% !important;
}

.ant-row input:focus-visible + .ant-input-group-addon {
    outline: 2px solid rgb(72, 156, 248);
}
.ant-row {
  position: relative;
  height: auto;
  padding: 0;
  color: #4d4d4d;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  margin-bottom: 24px;
  zoom: 1;
  display: block;
  box-sizing: border-box;
  cursor: pointer;
}
.ant-label {
  display: inline-block;
  overflow: hidden;
  line-height: 39.9999px;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}
.ant-col {
  position: relative;
  min-height: 1px;
}
.ant-row label {
  position: relative;
}
.ant-label > label {
  color: rgba(0,0,0,.85);
}
.ant-form-item-control {
  position: relative;
  line-height: 40px;
  zoom: 1;
}
.ant-form-item-children {
  position: relative;
}
.ant-input-group-wrapper {
  display: inline-block;
  width: 100%;
  text-align: start;
  vertical-align: top;
}
.ant-input-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #4d4d4d;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-input[disabled] {
  background: rgb(247, 249, 250);
}
.ant-input-group > .ant-input:first-child{
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input{
  height: 40px;
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
  touch-action: manipulation;
  -webkit-appearance: none;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  padding: 4px 11px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
  font-size: 14px;
  line-height: 1.5;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-input-group-addon:last-child{
  border-top-left-radius: 0;
border-bottom-left-radius: 0;
border-left: 0;
}
.ant-input-group-addon {
  position: relative;
  padding: 0 11px;
  color: #4d4d4d;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
}
.ant-input-group-addon, .ant-input-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}
.ant-input-group-addon, .ant-input-group-wrap, .ant-input-group > .ant-input {
  display: table-cell;
}
.svg-inline--fa.fa-w-14 {
  width: 0.875em;
}
.upload-dropzone-border {
    border: 0;
    background-image: url("data:image/svg+xml, %3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4px' ry='4px' stroke='%2389888D' stroke-width='2' stroke-dasharray='6%2c4' stroke-dashoffset='0' stroke-linecap='butt' /%3e %3c/svg%3e");
    border-radius: 4px;
}
  #loadingpage {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.97;
    background-color: #fff;
    z-index: 10000;
}
#loadingpage .loader {
  position: absolute;
    z-index: 30;
    left: 50%;
    width: 120px;
    margin-left: -65px;
    margin-bottom: 30px;
}
#loadingpage  .loader .spinner-ball-outer, .ecwid-loadingIndicator .loader .spinner-ball-outer {
    width: 88px;
    height: 88px;
    background: transparent url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='88' viewBox='0 0 88 88'%3E%3Cpath fill='none' stroke='%23275ce0' stroke-linecap='round' stroke-width='3' d='M64.8 79.5C58.4 83.3 51 85.5 43 85.5 27 85.5 13 76.6 5.8 63.5M64.4 6.2C77 13.6 85.5 27.3 85.5 43 85.5 50.7 83.4 58 79.8 64.2M.5 43C.5 19.5 19.5.5 43 .5' transform='translate(1 1)'/%3E%3C/svg%3E") center center no-repeat;
    background-size: contain;
    animation: spinright .8s infinite linear;
}

#loadingpage .loader .spinner-ball-inner, .ecwid-loadingIndicator .loader .spinner-ball-inner {
    width: 40px;
    height: 40px;
    margin: -64px auto 64px;
    background: transparent url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'%3E%3Cpath fill='%23275ce0' d='M20 39.5C9.2 39.5.5 30.8.5 20S9.2.5 20 .5 39.5 9.2 39.5 20c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5c0-9.1-7.4-16.5-16.5-16.5S3.5 10.9 3.5 20 10.9 36.5 20 36.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z'/%3E%3C/svg%3E") center center no-repeat;
    background-size: contain;
    animation: spinleft .5s infinite linear;
}
#loadingpage .loading-info {
    position: absolute;
    width: 100%;
    margin-top: 6em;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    color: #0a1c2e;
}
  .sous-s{
   color: #646878;
    background-color: #eff1f2;
    font-weight: 600;
    align-items: center;
    margin-top: 2px;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 5px;
    --bs-badge-padding-x: 0.5rem;
    --bs-badge-padding-y: 0.325rem;
    --bs-badge-font-size: 0.85rem;
    --bs-badge-font-weight: 600;
    --bs-badge-color: #ffffff;
    --bs-badge-border-radius: 0.425rem;
    padding: 2px 4px;
    font-size: 10px;
}
body {
  position: relative;
  overflow: inherit !important;
}
.tag_cities {
  width: 100%;
  max-width: 100%;
}
.tag_cities .tag {
  background: rgb(49 130 206 / 16%);
  border-radius: 20px;
  float: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 500;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 2px;
  margin-bottom: 5px;
  min-height: 28px;
  padding-right: 10px;
  color: rgba(0, 0, 0, 0.7);
  position: relative;
  padding-right: 0;
}
.vs-chip--text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-left: 10px;
}
.vs-chip--close {
  width: 20px;
  height: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  border: 0;
  margin: 0 4px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  cursor: pointer;
}
.tag_cities .tag [data-role="remove"]::after {
  content: "x";
  padding: 0px 2px;
  margin-bottom: 3px;
  font-size: 15px;
}
.tag_cities .tag [data-role="remove"] {
  margin-left: 8px;
  cursor: pointer;
}
main{
background-color: #f2f2f2;
}
.v-select  .vs__selected {
   white-space: nowrap !important;
}
.v-select .vs__dropdown-toggle {
  overflow-x: hidden !important;
}
.percent .percent__dec,.percent .dot{
    display: none;
}
.vs__selected-options{
  flex-wrap: inherit;
}
.vue-circular-progress .circle__progress--path {
    stroke-opacity: 0.2 !important; 
}
hr.hr-grey {
    margin-bottom: 0;
    margin-top: 5px;
    border-color: #706d6d;
}
hr.hr-grey {
    margin-bottom: 0;
    margin-top: 5px;
    border-color: #706d6d;
}
p.Note {
    font-size: 12px;
    background-color: #f6f6f6;
    padding: 11px;
    display: block;
    margin-bottom: 10px;
}
.table-messages{
  max-height: 500px;
  overflow: auto;
}
.table-messages th{
  font-size: 15px;
}
.error {
  color: #c62525;
}
.success {
  color: #25c631;
}
.warn {
  color: #ff9800;
}
.bg-error {
  background: #fdebeb;
}
.bg-success {
  background: #ccffd0;
}
.bg-warn {
  background: #fff8d1;
}
.tab-cc{
    /* padding: 10px;
    border-radius: 3px;
    box-shadow: 0 1px 3px 0 #c4c4c4;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 15%);
    border: 0;
    background: #e1e1e1; */
}
.s-sidebarwidget__yellow {
    border-color: hsl(47deg 65% 84%);
    background-color: hsl(47deg 87% 94%);
}
.sidebarwidget__yellow .s-sidebarwidget--header, .s-sidebarwidget__yellow .s-sidebarwidget--content {
    border-color: hsl(47deg 65% 84%);
}
.s-sidebarwidget--header.s-sidebarwidget__small-bold-text {
    font-size: 14px;
    font-weight: bold;
}
.s-sidebarwidget--header:first-child {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}
.s-sidebarwidget__yellow .s-sidebarwidget--header {
    background-color: #fbf3d5;
    color: #6b737c;
}
.s-sidebarwidget--item {
    margin: 12px 0;
    padding-left: 16px !important;
    padding-right: 16px !important;
}
.fc-light {
    color: hsl(210deg 7% 44%) !important;
}
.bbw1 {
    border-bottom-width: 1px !important;
}
.bb {
    border-bottom-style: solid !important;
    border-bottom-width: 1px !important;
}
.s-sidebarwidget--header {
    padding: 12px 15px;
    background: hsl(0deg 0% 98%);
}
.s-sidebarwidget--header, .s-sidebarwidget--content {
    border-top: 1px solid hsl(210deg 7% 89%);
}
.s-sidebarwidget {
    position: relative;
    border: 1px solid hsl(210deg 8% 85%);
    border-radius: 3px;
    font-size: 13px;
}
.intro-y {
    position: relative;
    transform: translateY(50px);
    -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
    animation: intro-y-animation .4s ease-in-out .33333s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    -webkit-animation-delay: .2s;
    animation-delay: .2s;
}
.text-smmm {
    font-size: 9px;
}
.box-1 {
    background: #f2f4f7;
    border: 2px solid #e8ebed;
    border-radius: 0.375rem;
}
.loidingconfirm svg{
  width: 30px;
}
.noselect {
    pointer-events: none;
}
 .seller-select .vs__dropdown-toggle {
    border: none;
}
  .vs__dropdown-toggle {
    border: none;
    } 
.disabled {
      pointer-events:none;
      color: #bfcbd9;
      cursor: not-allowed;
      background-image: none;
      background-color: #eef1f6;
      border-color: #d1dbe5;   
    }
.disabled-loading {
    pointer-events: none;
    cursor: not-allowed;
}
.vm2_body .ins-progress{
   position: absolute !important;
}
.h-14 {
    height: 3.5rem !important;
}
.modal-footer {
  overflow: auto;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
  border-top: 1px solid #ededed;
  padding-top: 15px;
  padding-bottom: 15px;
}
.mb-13 {
    margin-bottom: 4rem;
}
.mll-0{
  margin-left:0 !important
}
.vm2__header h4{
pointer-events: none;
}
.vm2__header h4,.vm2__header .vm2__close{
  font-weight: 600;
}
.vm2_wrapper{
  z-index: 11;
}
.vm2_body{
 max-height: 500px;
}
.text-green-600,.text-green-500{
   color: #19a69d;
}
.bg-green-600,.bg-green-700{
  background-color: #19a69d;
}
.hover\:bg-indigo-darker:hover {
    background-color: #2f365f;
}
.bg-indigo-darker {
    background-color: #2f365f;
}
.bg-indigo {
    background-color: #6574cd;
}
.hover\:bg-indigo:hover {
    background-color: #6574cd;
}
.flag-img {
  display: inline-block;
  height: 16px;
  width: 16px;
  vertical-align: text-top;
  line-height: 16px;
  margin-right: 5px;
}
.form-checkbox {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    display: inline-block;
    vertical-align: middle;
    background-origin: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    flex-shrink: 0;
    color: currentColor;
    background-color: #fff;
    border-color: #e2e8f0;
    border-width: 1px;
    border-radius: 0.25rem;
    height: 1.2em;
    width: 1.2em;
}

.form-checkbox:checked {
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
    border-color: transparent;
    background-color: currentColor;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
}
.alert-dialog {
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 9990;
  padding: 15px 25px;
  color: #444444;
  background-color: white;
  box-shadow: 0 15px 30px 5px #00000045;
  border-radius: 35px;
  cursor: pointer;
}
.alert-dialog.fadein {
  animation: fadein 1s;
}
.alert-dialog.fadeout {
  animation: fadeout 1s;
}
@keyframes fadein {
  0% {
    opacity: 0;
    transform: translate(-50%, 50%);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
@keyframes fadeout {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, 50%);
  }
}
.intro-y {
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.2s;
 animation-delay:.2s
}
.zoom-in:hover {
 --tw-shadow:0 20px 25px -5px rgba(0,0,0,0.1),0 10px 10px -5px rgba(0,0,0,0.04);
 box-shadow:0 3px 20px rgba(0,0,0,.043137254901960784);
 --tw-scale-x:1.05;
 --tw-scale-y:1.05
}
.zoom-in {
 cursor:pointer;
 --tw-translate-x:0;
 --tw-translate-y:0;
 --tw-rotate:0;
 --tw-skew-x:0;
 --tw-skew-y:0;
 --tw-scale-x:1;
 --tw-scale-y:1;
 transform:translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
 transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;
 transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;
 transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;
 transition-duration:.15s;
 transition-timing-function:cubic-bezier(.4,0,.2,1);
 transition-duration:.3s
}
.box {
    box-shadow: 0 3px 20px rgba(0,0,0,.043137254901960784);
    background-color: #fff;
    border-radius: .375rem;
}
.check {
    display: none;
    position: absolute;
    top: 5px;
    right: 5px;
}
i.tiny {
    font-size: 12px;
    line-height: 20px;
}
.feather-icon {
    display: inline-flex;
    align-items: center;
}
.active .check {
    display: block;
}
.intro-y.active{
  border: 2px solid rgba(103,240,114,.9) !important;
  background: rgba(103,240,114,.1) !important;
}
/*  Mobile css */
.mat-icon-button {
    padding: 0;
    min-width: 0;
    width: 35px;
    height: 35px;
    flex-shrink: 0;
    border-radius: 50%;
    box-sizing: border-box;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    outline: none;
    border: none;
    -webkit-tap-highlight-color: transparent;
    display: inline-block;
    white-space: nowrap;
    text-decoration: none;
    vertical-align: baseline;
    text-align: center;
    margin: 0;
    overflow: visible;
}

.loading-panel {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 16em;
    min-height: 8.75em;
    margin-top: -4.3em;
    margin-left: -8em;
    font-size: 14px;
    animation: zoom .3s 1 linear, fadein .5s 1 linear;
}
.check {
    display: none;
    position: absolute;
    top: 5px;
    right: 5px;
}
.check-left {
    position: absolute;
    top: 5px;
    left: 5px;
}
.active .check-left {
    display: block;
}
i.tiny {
    font-size: 12px;
    line-height: 20px;
}
.feather-icon {
    display: inline-flex;
    align-items: center;
}
.bg-ww {
  border: 2px solid #77d7c8;
  background-color: #f5f5f5;
  padding: 15px;
  max-height: 270px;
  min-height: 240px;
  overflow-y: auto;
}
.box-1 {
  background: #f2f4f7;
  border: 2px solid #77d8c8;
  border-radius: .375rem;
}
.active .check {
    display: block;
}
.intro-y.active{
  border: 2px solid rgba(103,240,114,.9);
  background: rgba(103,240,114,.1);
}
.warehouse .zoom-in:hover{
  margin-left: 8px;
  margin-right: 8px;
}
.warhouseparent .parent-warehouse{
  padding-left: 35px;
}
/*  Mobile css */
.mat-icon-button {
    padding: 0;
    min-width: 0;
    width: 35px;
    height: 35px;
    flex-shrink: 0;
    border-radius: 50%;
    box-sizing: border-box;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    outline: none;
    border: none;
    -webkit-tap-highlight-color: transparent;
    display: inline-block;
    white-space: nowrap;
    text-decoration: none;
    vertical-align: baseline;
    text-align: center;
    margin: 0;
    overflow: visible;
}
.tinytabs{
  margin-top: 10px;
}
.tinytabs .section .title{
   display: none;
}
.tinytabs .tabs {
	margin-left: 15px;
	display: flex;
	flex-flow: row wrap;
}
.tinytabs .tabs .tab .close {
	padding-left: 5px;
}
.tinytabs .tabs .tab {
	margin: 0 3px 0 0;
	background: #e1e1e1;
	display: block;
	padding: 6px 15px;
	text-decoration: none;
	color: #666;
	font-weight: bold;
	border-radius: 3px 3px 0 0;
  border: 1px solid black;
    border-bottom: none;
}
.tinytabs .section {
	background: #f1f1f12e;
    overflow: hidden;
    padding: 15px;
    clear: both;
    border-radius: 3px;
    min-height: 400px;
    border: 1px solid black;
}
.tinytabs .tab.sel {
	background: #f1f1f1;
	color: #333;
	text-shadow: none;
}


.tabs-component-tabs {
  border: solid 1px #504e4e;
  border-radius: 6px;
  margin-bottom: 5px;
}

@media (min-width: 700px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:not(:last-child) {
  border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (min-width: 700px) {
  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #504e4e;
    border-radius: 3px 3px 0 0;
    margin-right: .5em;
    transform: translateY(2px);
    transition: transform .3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    transform: translateY(0);
  }
}

.tabs-component-tab-a {
  align-items: center;
  color: inherit;
  display: flex;
  padding: .75em 1em;
  text-decoration: none;
}

.tabs-component-panels {
  padding: 1em 0;
}

@media (min-width: 700px) {
  .tabs-component-panels {
    border-top-left-radius: 0;
    background-color: #fff;
    border: solid 1px #504e4e;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .05);
    padding: 1em 1em
  }
}
.invoice-item-list .table {
    margin-bottom: 0;
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
}
.invoice-item-list table {
    border-collapse: collapse;
}
.invoice-item-list table thead tr {
    text-transform: uppercase;
    padding: 0.8rem 0;
    font-weight: 700;
    border-top: 1px solid;
    border-bottom: 1px solid;
    font-size: 1rem;
}
.invoice-item-list .table th.invoice-detail-margin {
    width: 8px;
    max-width: 8px;
}
.invoice-item-list .table td, .invoice-item-list .table th {
    padding: 0.25rem;
}
.invoice-item-list .table td, .invoice-item-list .table th {
    text-align: left;
    vertical-align: top;
}
.invoice-item-list .table th {
    padding: 0.7rem 0.5rem;
    border: none;
    font-weight: 500;
    -webkit-font-smoothing: antialiased;
}
.invoice-item-list .table th {
    text-align: right;
    vertical-align: top;
    background: rgba(49,130,206,.31);
}
.invoice-item-list .table td.item-row-summary, .invoice-item-list .table th.invoice-detail-summary {
    text-align: left;
    width: 50%;
}
.invoice-item-list .table td, .invoice-item-list .table th {
    text-align: left;
    vertical-align: top;
}
.invoice-items tr {
    border-bottom: 1px dashed #7b7878;
}
.item-row {
    transition: transform .5s ease-out;
}
.item-row .item-row-actions {
    width: 50px;
}
.item-row .item-row-actions .btn {
    min-width: 35px;
    padding: 4px;
}

.item-row .btn {
    -webkit-font-smoothing: antialiased;
    font-weight: 500;
    color: #555;
    background: #f4f4f4;
    background: linear-gradient(#f4f4f4,#e4e4e4);
    border-radius: 3px;
    border: 1px solid #999;
    display: inline-block;
    padding: 4px;
    overflow: hidden;
    text-decoration: none;
    min-width: 34px;
    cursor: pointer;
    transition: .1s ease-in;
    font-size: inherit;
}
.svg-inline--fa.fa-w-11 {
    width: 0.6875em;
}
.svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
}
.item-row-name {
    display: block;
}
.invoice-items tr.item-row-n {
    border: none;
}
.item-row {
    transition: transform .5s ease-out;
}
.invoice-item-list .table td, .invoice-item-list .table th {
    padding: 0.25rem;
}
.item-row .item-row-actions {
    width: 50px;
}
.item-row .btn.btn-prime {
    background: #444;
    background: linear-gradient(#555,#444);
    color: #fff;
    font-weight: 500;
}
.item-row .item-row-actions .btn {
    min-width: 35px;
    padding: 4px;
}
.item-row .btn {
    -webkit-font-smoothing: antialiased;
    font-weight: 500;
    color: #555;
    background: #f4f4f4;
    background: linear-gradient(#f4f4f4,#e4e4e4);
    border-radius: 3px;
    border: 1px solid #999;
    display: inline-block;
    padding: 4px;
    overflow: hidden;
    text-decoration: none;
    min-width: 30px;
    cursor: pointer;
    transition: .1s ease-in;
    font-size: inherit;
}
</style>
